<script setup lang="ts">
import { computed } from 'vue'

import { classMerge } from '../../utils'

const props = defineProps<{
  // eslint-disable-next-line vue/no-reserved-props
  class?: string
}>()

const className = computed(() => classMerge('w-full h-px bg-gray-200 my-2 first:mt-0 last:mb-0', props.class))
</script>

<template>
  <li :class="className" />
</template>
